import { differenceInYears, parseISO } from "date-fns";

export const getAge = (birthday?: string): string => {
  if (!birthday) {
    return "-";
  }
  return differenceInYears(new Date(), parseISO(birthday)).toString();
};
